import gUpload from './gUpload'
import loadAbleCard from './loadAbleCard'

const install = {
  install: function(Vue) {
    Vue.component('gUpload', gUpload)
    Vue.component('loadAbleCard', loadAbleCard)
  }
}

export default install
